import React, { createContext, useState } from "react";
import { IFleetContext } from "../types/fleet";
import { IEmissionClass, IEngineType, IVehicleInfo, Vehicle, VehicleCategory } from "../types/vehicles";

export const FleetContext = createContext<null | IFleetContext>(null);

interface Props {
    children: React.ReactNode
}

export const FleetProvider: React.FC<Props> = ({ children }) => {
    const [emissionClass, setEmissionClass] = useState<IEmissionClass[]>([]);
    const [engineType, setEngineType] = useState<IEngineType[]>([]);
    const [vehicles, setVehicles] = useState<Vehicle[]>([]);    
    const [vehiclesInfo, setVehiclesInfo] = useState<IVehicleInfo[]>([]);  
    const [isIntermodal, setIsIntermodal] = useState<boolean>(false);  
    const [lastUpdate, setLastUpdate] = useState<string | null>(null);  

    const value: IFleetContext = {
        engineType,
        setEngineType,
        emissionClass,
        setEmissionClass,
        vehicles,
        setVehicles,
        vehiclesInfo,
        setVehiclesInfo,
        isIntermodal,
        setIsIntermodal,
        lastUpdate,
        setLastUpdate
    };

    return (
        <FleetContext.Provider
            value={value}
        >
            {children}
        </FleetContext.Provider>
    );
};